import { LegalShell, LegalSection, LegalList, SupportLink } from "../site/LegalShell.jsx";

export default function PrivacyPage() {
  return (
    <LegalShell
      eyebrow="Legal"
      title="Privacy policy"
      intro="What we collect when you search and book through Aloha Rates, why we collect it, and who else sees it."
      updated="6 September 2026"
    >
      <LegalSection heading="Who we are">
        <p>
          Aloha Rates is an online travel agency for Hawaiʻi. We show rates for hotels, resorts, condos and
          vacation rentals across the six main islands and let you book them. This policy covers aloharates.com
          and the booking flow that runs on it.
        </p>
      </LegalSection>

      <LegalSection heading="What we collect">
        <LegalList items={[
          <><strong>Search details.</strong> Islands, areas and properties you look at, your dates, and the number and ages of guests. We need these to price a stay at all.</>,
          <><strong>Booking details.</strong> The lead guest's name, email address, phone number, the names of other guests on the reservation, and any special requests you type in.</>,
          <><strong>Payment details.</strong> Card data is entered into, and handled by, our payment provider. Aloha Rates does not store your full card number.</>,
          <><strong>Technical data.</strong> IP address, browser and device type, and pages visited, in ordinary web server logs.</>,
          <><strong>Anything you send us.</strong> The contents of emails to support, including whatever you choose to include in them.</>
        ]}/>
      </LegalSection>

      <LegalSection heading="Why we use it">
        <p>
          To search for and price availability, to make and hold your reservation, to send you a confirmation and
          any necessary updates about your stay, to answer your questions, to detect and prevent fraud, and to keep
          the site working and reasonably fast. We do not sell your personal information.
        </p>
      </LegalSection>

      <LegalSection heading="Who else sees it">
        <LegalList items={[
          <><strong>The property you book.</strong> A reservation only exists once the accommodation provider has the guest names and stay dates. They handle that data under their own privacy policy.</>,
          <><strong>Our supply partner.</strong> Rates, availability and reservations are transacted through a third-party accommodation supplier that connects us to properties.</>,
          <><strong>Our payment provider.</strong> To take payment and process any refund.</>,
          <><strong>Service providers.</strong> Hosting, content delivery and email delivery, acting on our instructions.</>,
          <><strong>Authorities.</strong> Where we are legally required to disclose, or need to establish or defend a legal claim.</>
        ]}/>
      </LegalSection>

      <LegalSection heading="Cookies and local storage">
        <p>
          We use browser storage to remember your search — dates, guests, the property you were last looking at —
          so that moving between pages does not throw your trip away, and to keep a booking coherent from search
          through to checkout. We do not use it to build an advertising profile of you. Blocking storage entirely
          will break the booking flow, because a reservation in progress has nowhere to live.
        </p>
      </LegalSection>

      <LegalSection heading="How long we keep it">
        <p>
          Reservation records are kept for as long as we need them to service the booking and to meet tax,
          accounting and dispute-resolution obligations. Server logs are kept for a short operational period.
          Support correspondence is kept while it is useful for helping you.
        </p>
      </LegalSection>

      <LegalSection heading="Your rights">
        <p>
          You can ask us for a copy of the personal information we hold about you, ask us to correct it, or ask us
          to delete it. Depending on where you live — California, the EEA, or the UK among others — you may have
          additional rights, including the right to object to certain processing and the right to complain to your
          local data protection authority. Email <SupportLink/> and say what you want; we will not charge you for
          asking, and we will not treat you differently for having asked.
        </p>
        <p>
          Note that we cannot delete information we still need in order to deliver a stay you have booked, or that
          we are required to keep for tax and accounting purposes.
        </p>
      </LegalSection>

      <LegalSection heading="Children">
        <p>
          The site is not directed at children, and we do not knowingly collect personal information from anyone
          under 13 other than the guest names required to complete a family reservation.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to this policy">
        <p>
          If we change how we handle personal information we will update this page and move the “last updated”
          date at the top. Material changes will be flagged more prominently than that.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>Privacy questions and requests go to <SupportLink/>.</p>
      </LegalSection>
    </LegalShell>
  );
}
